export const initialScheduleData = {
  manage_schedule_shift: false,
  allow_schedule_overlapping: false,
  show_employees_sched_assigned_users: false,
  requires_schedule_to_clock_in: false,
  requires_schedule_to_clock_within_period: { label: '0 min', value: 0 } as any,
};
